import React from 'react'

type Props = {
    id?: string,
    btnType: "button" | "submit" | "reset" | undefined,
    btnText?: string | React.ReactNode,
    btnImg?: string,
    btnImgStyle?: string,
    btnIcon?: JSX.Element,
    btnStyle?: string,
    disabled?: boolean,
    disabledClass?: string,
    onClick?: (e: any) => void,
    handleMouseHover?: (e: any) => void
} 

const Button = ({id, btnType, btnText, btnImg, btnImgStyle, btnIcon, btnStyle, disabled, disabledClass, onClick, handleMouseHover}:Props) => {
    
    return (
        <button 
            id={id}
            type={btnType} 
            className={`${btnStyle} ${disabled ? disabledClass : 'hover:shadow-md hover:transition-all' } flex justify-center gap-3 items-center rounded-md`} 
            onClick={onClick}
            onMouseEnter={handleMouseHover}
            disabled={disabled}
        >
            {btnText &&
                <span>
                    {btnText}
                </span>
            }
            {btnIcon &&
                <span>
                    {btnIcon}
                </span>
            }
            {btnImg &&
                <span>
                    <img src={btnImg} alt='btn_icon' className={`${btnImgStyle}`}/>
                </span>
            }
        </button>
    )
}

export default Button